module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[114]235.8475e12.woff2";